import { ProductType } from '@/types';
import { getHasWarning } from './getHasWarning';
import { WarningTypes } from './warningTypes';

export const getIsBlankVerboten = (productType: ProductType) =>
  getHasWarning(productType, WarningTypes.NoBlank);
